import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import {Menu , MenuDivider, MenuItem,Button, Icon,Intent}from '@blueprintjs/core';



@inject("store")
@observer
export default class NoteListItem extends Component
{
    show(e){
        //编辑状态解除
        this.props.store.is_editing = false;
        //如果更改了分数，刷新分数。
        if(this.props.store.starchange!=0){
            this.forceUpdate();
        }
        //更改保存路径，读取保存过的内容
        this.props.store.savepath = this.props.data.name;
        this.props.store.appname= this.props.data.name;

        let cat = localStorage.getItem(this.props.store.savepath);
        if (cat == null){
            cat = "这是练习区域  请单击编辑按钮开始练习。";
        }
        this.props.store.current_note_parctise = cat;
        
        
        //点击notelist换内容
        this.props.store.getnotepageready(this.props.data.name);

        /*    if(this.props.data.name=="狡猾，泳装，鲁迅全集"){
                this.props.store.current_note_markdown = `这是第一篇三题作文！！`;
                this.props.store.is_title = 1;
                if( this.props.store.view_type == 2 ) this.props.store.view_type = 3;
            }*/
        
    }
    render()
    {
        return <div className="item" onClick={e=>this.show(e)}>{this.props.data.name}       {localStorage.getItem(this.props.data.name)==null ?<></>:
         <>
        {localStorage.getItem(this.props.data.name+"star")=="完美"&&<>
        <Icon icon = "small-tick" intent = {Intent.SUCCESS} />
        <Icon icon = "small-tick" intent = {Intent.SUCCESS}/>
        
        </>}

        {localStorage.getItem(this.props.data.name+"star")=="挺好"&&<>
        <Icon icon = "small-tick" intent = {Intent.SUCCESS} />
        
        </>}

        {localStorage.getItem(this.props.data.name+"star")=="还行"&&<>
        <Icon icon = "small-tick" intent = {Intent.PRIMARY} />
        
        </>}

        {localStorage.getItem(this.props.data.name+"star")=="较差"&&<>
        <Icon icon = "small-tick" intent = {Intent.WARNING} />
        
        </>}

        {localStorage.getItem(this.props.data.name+"star")=="很差"&&<>
        <Icon icon = "small-tick" intent = {Intent.DANGER} />
        
        </>}

        {localStorage.getItem(this.props.data.name+"star")==null &&<>
        <Icon icon = "small-tick" intent = {Intent.NONE} />
        
        </>}
         
         
         </>}</div>;
    }
}